import ACTIONS_REPORT_DEFINITION_PARAMETER from '../_constants/reportDefinitionParameter.constants';

const initialState = {
  byId: {},
};

export function reportDefinitionParameterReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case ACTIONS_REPORT_DEFINITION_PARAMETER.INVALIDATE: {
      return {
        ...initialState,
      };
    }

    case ACTIONS_REPORT_DEFINITION_PARAMETER.DELETE:
    {
      const currentById = { ...state.byId };
      delete currentById[Object.keys(action.byId)[0]];

      return {
        ...state,
        byId: currentById,
      };
    }

    case ACTIONS_REPORT_DEFINITION_PARAMETER.RECEIVE: {
      return {
        ...state,
        byId: { ...state.byId, ...action.byId },
      };
    }

    default:
      return state;
  }
}

export default reportDefinitionParameterReducer;
